var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('oie-base-button',{attrs:{"is-type":"a","url":_vm.url,"css-classes":"button-link button-link--narrow skip-link","text":_vm.proxyText},on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }